import { makeAutoObservable, toJS } from 'mobx'

import { TouristValues } from 'entities/tour/ui/purchase-form-tours/model.ts'

import { TYPE_AGE } from 'shared/constants'
import { IPhoneInput } from 'shared/ui/phone-input'

interface SetTouristData {
  index: number
  age: TYPE_AGE.ADULTS | TYPE_AGE.CHILDREN
  scannedData: TouristValues
}

export interface FormTouristValues {
  email?: string
  phoneNumber?: IPhoneInput
  [TYPE_AGE.ADULTS]: TouristValues[]
  [TYPE_AGE.CHILDREN]: TouristValues[]
}

class FormTouristStore {
  formTourist: FormTouristValues | null = null

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  setValuesForm(data: FormTouristValues) {
    this.formTourist = data
  }

  getValuesForm() {
    return toJS(this.formTourist)
  }

  clearValuesForm() {
    this.formTourist = null
  }

  setPassengerData({ index, age, scannedData }: SetTouristData) {
    if (!this.formTourist) {
      return
    }

    this.formTourist[age][index] = scannedData
  }
}

export default new FormTouristStore()
